var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cover"},[_c('img',{attrs:{"src":_vm.src,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }